import React from 'react';
import { Box, Table } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { TableHeaderTooltip } from '@epi-pages/Reports/TableHeaderTooltip';

export const CardOrdersTableHead = () => {
  const { t } = useTranslation();

  return (
    <Table.Row>
      <Table.Cell id="card-orders-request-date">
        {t('containers.deposit_money.card_orders_tab.order_date')}
      </Table.Cell>
      <Table.Cell id="card-orders-employee">
        {t('containers.deposit_money.card_orders_tab.employee')}
      </Table.Cell>
      <Table.Cell id="card-orders-email">
        {t('containers.deposit_money.card_orders_tab.email')}
      </Table.Cell>
      <Table.Cell id="card-orders-status">
        {t('containers.deposit_money.card_orders_tab.status')}
      </Table.Cell>
      <Table.Cell id="card-orders-card-type" align="left">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          width="100%"
        >
          {t('containers.deposit_money.card_orders_tab.card')}
          <TableHeaderTooltip
            tooltipText={t(
              'containers.deposit_money.card_orders_tab.card_info'
            )}
          />
        </Box>
      </Table.Cell>
    </Table.Row>
  );
};
